













import { Component, Vue } from "vue-property-decorator";
import store from "@/stores/store";
import LinkToolsEnglishLinks from "@/pages/links-tools/english-links.vue";
import LinkToolsFrenchLinks from "@/pages/links-tools/french-links.vue";

@Component({ name: "link-tools-page",
  components: {LinkToolsEnglishLinks, LinkToolsFrenchLinks}
})
export default class LinkToolsPage extends Vue {
  private LOCAL_FR = "FR";
  private LOCAL_GB = "GB";

  private locale = store.getters["user/getLocale"] === "fr" ? this.LOCAL_FR : this.LOCAL_GB;

  private links = {
    PHOTOS: {name: this.$t('links.photos'), link: 'https://app.cargosnap.com/login' },
    CONNECT_1: {name: this.$t('links.connect'), link: 'https://app.shiptify.com/dock' },
    TUTO: {name: this.$t('links.tuto'), link: 'https://www.youtube.com/watch?v=LRvF9GDpIv0' },
    CONNECT_2: {name: this.$t('links.connect'), link: 'https://easychargeur.akanea.com/' },
    NOTICE: {name: this.$t('links.notice'), link: 'https://www.dartess.fr/wp-content/uploads/2023/07/Manuel-Utilisation-Station-chargeur-Dartess-V.07.2023-1.pdf' },
    CONNECT_3: {name: this.$t('links.connect'), link: 'https://documents.dartess.fr/login' }
  };

  async beforeMount() {
    this.$route.meta.title = this.$t("links.title");
  }
}
